import React from "react";
import "./experience.css";
import { BsPatchCheckFill } from "react-icons/bs";

const Experience = () => {
  return (
    <section id="experience">
      <h5>Technical Expertise</h5>
      <h2>Backend & Systems Engineering</h2>

      <div className="container experience__container">

        {/* Backend Development */}
        <div className="experience__section">
          <h3>Backend Development</h3>
          <div className="experience__content">

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>PHP</h4>
                <small>Application & Business Logic Development</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Laravel</h4>
                <small>MVC Architecture & RESTful APIs</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>ColdFusion</h4>
                <small>Enterprise Web Application Development</small>
              </div>
            </article>

          </div>
        </div>

        {/* Database Engineering */}
        <div className="experience__section">
          <h3>Database Engineering</h3>
          <div className="experience__content">

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>MySQL</h4>
                <small>Schema Design, Joins & Query Optimization</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>MSSQL</h4>
                <small>Stored Procedures & Performance Tuning</small>
              </div>
            </article>

          </div>
        </div>

        {/* Cloud & Infrastructure */}
        <div className="experience__section">
          <h3>Cloud & Infrastructure</h3>
          <div className="experience__content">

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>AWS EC2</h4>
                <small>Application Deployment & Networking</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Azure Networking</h4>
                <small>Hub-Spoke Architecture & Firewall Setup</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Terraform</h4>
                <small>Infrastructure as Code</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Windows Server</h4>
                <small>Server Configuration & Environment Management</small>
              </div>
            </article>

          </div>
        </div>

        {/* Version Control & Collaboration */}
        <div className="experience__section">
          <h3>Version Control & Collaboration</h3>
          <div className="experience__content">

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Git & GitHub</h4>
                <small>Branching, Pull Requests & Code Reviews</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Project Management</h4>
                <small>Agile Workflow & Task Planning</small>
              </div>
            </article>

          </div>
        </div>

        {/* Supporting Frontend Knowledge */}
        <div className="experience__section">
          <h3>Frontend Knowledge</h3>
          <div className="experience__content">

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>React</h4>
                <small>Component-Based UI Development</small>
              </div>
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>JavaScript</h4>
                <small>Client-Side Logic</small>
              </div>
            </article>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Experience;